// Generated from shared/legal/privacy-policy.json. Do not edit.
module.exports = {
  "privacyComplianceMeta": {
    "appName": "佣值选 Android 客户端软件",
    "shortName": "佣值选",
    "operator": "深圳市礼屋科技有限公司",
    "contactAddress": "中华人民共和国广东省深圳市",
    "supportEmail": "944195790@qq.com",
    "policyVersion": "6.0",
    "consentVersion": 6,
    "effectiveDate": "2026年09月09日",
    "updatedDate": "2026年09月22日",
    "responseTime": "十五个工作日",
    "documentRevision": "2026-09-22-online-legal-ai-scope",
    "storageLocation": "中华人民共和国境内，当前主要使用阿里云中国大陆节点保存和处理数据",
    "crossBorder": {
      "status": "none",
      "description": "根据当前产品和生产配置，我们不主动向中华人民共和国境外提供个人信息。将来如发生跨境提供，我们会依法另行告知接收方、目的、方式、信息种类和保护措施，并履行相应程序。"
    },
    "scope": "适用于佣值选 Android 客户端、公开下载及法律文档网页，以及与客户端配套的账号、商品导购、返利、会员、钱包、提现、客服等服务，具体以当前版本与渠道实际开放的功能为准。"
  },
  "privacyComplianceDocuments": {
    "userAgreement": {
      "title": "用户协议",
      "summary": "使用佣值选前请阅读本协议，了解服务范围、第三方平台边界、账号安全和争议处理规则。",
      "sections": [
        {
          "title": "协议主体与接受",
          "paragraphs": [
            "本协议由用户与深圳市礼屋科技有限公司订立，适用于佣值选 Android 客户端及相关服务。用户应在充分阅读用户协议和隐私政策后自主决定是否注册、登录或使用相应功能。",
            "不同意可选个人信息处理时，用户仍可使用匿名商品浏览、搜索和详情；登录、返利、支付和提现等功能按其必要条件另行提供；AI导购仅在当前版本或渠道开放时适用。"
          ],
          "paragraphStyles": [
            "normal",
            "normal"
          ]
        },
        {
          "title": "服务内容与交易边界",
          "paragraphs": [
            "佣值选提供商品浏览、搜索、价格比较、优惠展示、淘宝返利归因、会员、钱包、提现、价格提醒和帮助中心等服务，具体以当前版本与渠道实际开放的功能为准。AI导购仅在明确开放该功能的版本或渠道提供，未开放时无法使用。",
            "商品下单、支付、配送、退换货和开票等交易由相应第三方电商平台或支付机构提供，具体商品、库存、价格、优惠和售后规则以第三方页面为准。佣值选负责其自身提供的会员、返利、钱包和客服服务。"
          ],
          "paragraphStyles": [
            "normal",
            "normal"
          ]
        },
        {
          "title": "账号与安全",
          "paragraphs": [
            "用户应使用本人合法、有效的手机号注册或登录，妥善保管验证码和登录状态，不得通过虚假交易、恶意注册、批量抓取、作弊等方式获取权益或干扰服务。",
            "发现账号被盗、异常支付或其他安全风险时，应立即通过帮助中心或客服邮箱联系我们。"
          ],
          "paragraphStyles": [
            "normal",
            "normal"
          ]
        },
        {
          "title": "会员、返利与提现",
          "paragraphs": [
            "会员权益、返利比例、提现条件、手续费和到账时间以购买或操作页面实时展示及有效规则为准。支付成功后方开通会员；订单退款、取消或佣金调整可能导致返利状态和金额相应变化。",
            "申请提现前应处理未结算权益并使用本人合法的收款账户。因用户提供错误信息、第三方渠道故障或依法进行风险核查导致延迟时，我们会展示状态或提供处理渠道。"
          ],
          "paragraphStyles": [
            "normal",
            "normal"
          ]
        },
        {
          "title": "AI 导购（仅限已开放版本或渠道）",
          "paragraphs": [
            "AI导购为可选功能。当前版本或渠道未开放时，不提供对话导购服务；开放后，用户须先阅读并确认AI数据处理说明，再主动提交问题。",
            "AI导购基于用户输入和现有商品数据生成建议，属于人工智能生成内容，仅供购物参考，不构成价格、质量、功效、投资、医疗或其他专业承诺。用户应以第三方平台实时信息和自身判断作出交易决定。",
            "使用的模型和备案信息在AI数据处理说明及产品页面公示。用户不得输入国家秘密、他人敏感个人信息或违法内容。"
          ],
          "paragraphStyles": [
            "normal",
            "normal",
            "normal"
          ]
        },
        {
          "title": "账号注销与协议终止",
          "paragraphs": [
            "用户可通过“我的-设置-账号与安全-注销账号”申请注销。存在未结余额、处理中提现、支付退款或返利结算时，需先处理相应事项；已完成历史交易本身不阻止注销。",
            "注销成功后账号标记为已注销并停止登录，原账号不可恢复。注销不免除注销前交易产生的结算、退款、争议处理或依法应承担的责任，相关个人信息按隐私政策和分类留存规则处理。"
          ],
          "paragraphStyles": [
            "normal",
            "normal"
          ]
        },
        {
          "title": "服务变更、停止与争议",
          "paragraphs": [
            "我们可能因维护、安全、监管、第三方平台变化或不可抗力调整、中止部分服务，并尽力提前告知和减少影响。停止运营时将停止继续收集个人信息，并依法处理已保存信息。",
            "本协议适用中华人民共和国法律。发生争议时双方可先协商；协商不成的，可依法向有管辖权的人民法院处理。"
          ],
          "paragraphStyles": [
            "normal",
            "normal"
          ]
        },
        {
          "title": "联系我们",
          "paragraphs": [
            "协议、服务、投诉或账号问题可通过App内帮助中心或客服邮箱 944195790@qq.com 联系深圳市礼屋科技有限公司。"
          ],
          "paragraphStyles": [
            "normal"
          ]
        }
      ]
    },
    "privacyPolicy": {
      "title": "隐私政策",
      "summary": "本政策说明佣值选处理个人信息、权限、第三方服务和用户权利的方式。",
      "sections": [
        {
          "title": "提示、适用范围与处理者",
          "paragraphs": [
            "我们重视个人信息保护。请特别关注以醒目方式标识的敏感个人信息、第三方处理、自动化决策和用户权利内容，并根据需要作出选择。",
            "本政策的个人信息处理者为深圳市礼屋科技有限公司，联系地域为中华人民共和国广东省深圳市，客服及隐私投诉邮箱为 944195790@qq.com。",
            "本政策适用于佣值选Android客户端、公开下载及法律文档网页和配套服务，不适用于由淘宝、支付宝、微信等第三方独立提供并由其决定处理规则的服务。"
          ],
          "paragraphStyles": [
            "normal",
            "normal",
            "normal"
          ]
        },
        {
          "title": "我们如何收集和使用个人信息",
          "paragraphs": [
            "匿名基础浏览、搜索和商品详情：处理搜索关键词、商品标识、平台来源、IP地址、请求时间和网络日志。来源：用户输入、客户端请求和服务器自动生成。目的：返回商品列表、搜索结果和详情，保障接口安全与稳定。方式：通过 HTTPS 传输；匿名基础浏览不携带登录令牌，不写入账号浏览或收藏历史。触发时机：用户打开基础浏览、搜索或详情时。保存：搜索趋势记录不绑定用户账号；网络安全日志至少保存6个月，期满按安全和审计规则处理。拒绝影响：不联网无法获取在线商品数据。控制方式：可以停止搜索或退出应用。",
            "手机号注册、登录、换绑和注销验证：处理手机号码、短信验证码校验结果、用户ID、访问令牌、刷新令牌、账号状态。来源：用户主动提供及系统生成。目的：识别账号、保护账号安全和提供账户服务。方式：HTTPS传输，验证码和令牌按短期有效期校验，密码或令牌不向第三方公开。触发时机：用户主动注册、登录、换绑手机号或注销账号时。本项涉及敏感个人信息。必要性：手机号用于完成账号身份验证，是登录和资金权益归属的必要信息；可能影响：泄露可能导致骚扰、账号冒用或财产风险，因此采用脱敏展示、限流和访问控制；同意方式：在注册登录及相应高风险操作页面取得明确同意和主动提交。保存：验证码通常保存5分钟；令牌按有效期保存；账号资料在账号服务期间保存，注销后按软标识和分类留存规则处理。拒绝影响：无法登录和使用返利、会员、钱包、提现、收藏等账号功能。控制方式：可退出登录、换绑手机号或申请注销账号。",
            "个人资料：处理昵称、头像图片、头像地址。来源：用户主动填写或上传。目的：展示个人资料并便于客服识别。方式：头像经服务端校验和压缩后保存到阿里云 OSS。触发时机：用户主动编辑资料时。保存：在使用对应资料期间保存，更换后旧引用停止使用；注销后按分类留存规则处理。拒绝影响：不影响基本浏览、登录和交易权益。控制方式：可在个人资料页修改。",
            "浏览、收藏、搜索偏好和推荐设置：处理搜索关键词、浏览记录、收藏记录、商品点击、推荐开关。来源：用户使用功能时产生。目的：展示历史、收藏和通用推荐，改善商品发现体验。方式：部分记录保存在本地，账号关联记录通过HTTPS保存至服务端；当前关闭个性化推荐后使用不基于个人画像的通用排序。触发时机：用户搜索、浏览、收藏或调整推荐设置时。保存：本地记录保存至用户清理、退出相关流程或卸载；服务端记录在功能使用期间保存，注销后按分类留存规则处理。拒绝影响：不影响基本浏览和搜索，但无法获得历史、收藏或相应偏好体验。控制方式：可清理历史、取消收藏并在隐私管理中关闭个性化推荐。",
            "剪贴板商品识别：处理用户主动粘贴或单独开启自动识别后的剪贴板文本。来源：设备剪贴板。目的：识别淘宝商品链接或口令并展示商品预览。方式：默认不读取；用户主动粘贴时单次读取，或单独开启后在进入首页/回到前台时读取一次；不保存无关原文。触发时机：主动点击粘贴，或已开启自动识别且首页获得焦点时。保存：仅在当前识别流程处理，不保存剪贴板原文；本地只记录不可逆内容标识用于避免重复提示。拒绝影响：不影响其他功能，可手动输入商品关键词。控制方式：可在隐私管理随时关闭自动识别。",
            "价格监控与后台提醒：处理登录账号ID、商品标识、目标价格、监控状态、通知投递状态。来源：用户主动设置及系统任务产生。目的：联网检查已监控商品价格并在达到条件时通知用户。方式：用户启用后由Android WorkManager按系统调度周期联网检查，通常最短间隔15分钟；设备重启后可恢复计划。触发时机：用户主动添加价格监控且同意当前隐私政策、账号有效时。保存：监控设置保存至用户取消、商品失效或权益终止；待投递提醒通常最多保留72小时。拒绝影响：关闭后不会收到相应降价提醒，不影响商品浏览。控制方式：可删除价格监控、关闭应用内通知设置或系统通知权限。",
            "淘宝授权、购买跳转、订单归因和返利：处理一次性授权state、淘宝渠道关系ID、订单号、商品、订单金额、佣金、返利、结算和退款状态。来源：用户授权、淘宝联盟和订单同步接口。目的：生成推广链接、关联淘宝订单、计算返利、处理结算和退款。方式：客户端跳转淘宝授权，服务端以加密凭据调用淘宝接口并按订单号幂等处理。触发时机：用户主动授权或购买并满足淘宝订单回流条件时。本项涉及敏感个人信息。必要性：交易和渠道关系信息用于确定订单归属、返利金额及退款责任；可能影响：泄露可能暴露消费和财产状况，因此限制访问并对凭据加密保存；同意方式：在淘宝渠道授权前单独提示并由用户主动确认。保存：授权state通常10分钟内有效；交易及返利信息自交易完成之日起至少保存3年，法律法规要求更长的从其规定。拒绝影响：仍可浏览商品，但无法追踪淘宝订单及获得对应返利。控制方式：可拒绝或撤回淘宝渠道授权；既有订单继续按结算、退款和法定义务处理。",
            "会员购买和支付：处理会员方案、支付订单号、支付宝交易号、支付金额、支付状态、退款状态。来源：用户下单、支付宝回调和服务端查单。目的：创建会员订单、确认支付、开通权益、处理退款和争议。方式：服务端签名下单并验证支付宝回调签名、金额、订单归属和幂等状态。触发时机：用户主动选择会员并发起支付宝支付时。本项涉及敏感个人信息。必要性：交易信息是确认付款、提供会员权益和处理售后的必要信息；可能影响：泄露可能暴露交易和财产信息，因此采用加密传输、签名校验和最小权限；同意方式：购买页展示价格和权益后由用户主动确认支付。保存：支付和会员交易信息自交易完成之日起至少保存3年，适用会计、税务或争议规则要求更长的从其规定。拒绝影响：无法购买会员，不影响免费基础服务。控制方式：可取消未支付订单，并通过帮助中心咨询支付或退款。",
            "支付宝收款账户、实名资料和提现：处理姓名、身份证件号码、支付宝账号标识、提现金额、手续费、到账金额、渠道流水号、提现和风险状态。来源：用户主动提交、支付宝授权及转账查询结果。目的：绑定收款账户、校验提现资格、转账、对账、税务和争议处理。方式：收款账号按配置加密保存，身份证件和资金记录限制后台访问；当前姓名和身份证号仅按用户提交保存，尚未接入权威实名认证供应商。触发时机：用户主动绑定支付宝、提交实名资料或申请提现时。本项涉及敏感个人信息。必要性：身份和金融账户信息用于确认收款人、保护资金安全及履行适用财税义务；可能影响：泄露可能造成身份冒用、诈骗或财产损失，因此需要单独同意、加密传输和访问控制；同意方式：在提交实名资料、绑定收款账户和提现确认页面分别取得主动确认。保存：提现和账务信息自交易完成之日起至少保存3年，适用财税或反欺诈规则要求更长的从其规定；授权临时参数到期失效。拒绝影响：无法绑定收款账户或提现，不影响商品浏览和已取得权益查询。控制方式：可在不存在处理中提现时解绑或更换支付宝账户，并通过帮助中心申请个人信息权利。",
            "帮助中心与问题反馈：处理反馈标题和正文、工单消息、用户主动上传的图片、联系方式、工单状态和处理记录。来源：用户主动提交及客服处理产生。目的：定位问题、回复用户、处理投诉和争议。方式：正文保存至受限工单系统，附件校验后保存至阿里云OSS；客服按角色访问。触发时机：用户主动提交反馈、回复工单或上传附件时。保存：未关联工单的临时附件按后台清理规则处理；已提交内容保存至问题处理完成及必要争议期结束，之后删除或匿名化。拒绝影响：无法通过工单获得针对性帮助，可使用公开客服邮箱联系。控制方式：提交前可不添加附件；可通过工单或客服邮箱申请处理相关信息。",
            "AI 导购（仅限已开放版本或渠道）：处理用户购物问题、本页对话、相关商品信息、用户主动粘贴的解析内容。来源：用户主动输入及服务端商品数据。目的：生成购物需求分析、候选商品和导购建议。方式：经单独说明和确认后，由服务端将必要上下文发送至DeepSeek API；返回内容经商品事实校验或使用本地兜底。触发时机：当前版本或渠道开放AI导购，且用户主动进入并同意AI数据处理说明后提交问题时；未开放时不通过该功能处理对话内容。保存：佣值选仅在当前页面会话中保留上下文，不保存为长期账号聊天历史。拒绝影响：无法使用AI导购，不影响商品搜索、浏览和其他服务。控制方式：可拒绝、关闭页面或停止输入；已发送内容的权利请求可联系帮助中心。",
            "账号、接口和资金安全：处理IP地址、请求时间、接口结果、应用版本、设备型号和系统版本、实际提供时的设备指纹、风险事件和不可逆关联标识。来源：客户端请求、服务器日志和安全规则产生。目的：身份验证、限流、防刷、反作弊、资金风险判断、故障排查和安全审计。方式：通过访问控制、限流和日志审计处理；风险关联值使用独立HMAC密钥，不把哈希结果视为匿名化。触发时机：登录、高风险操作、接口异常或安全事件发生时。保存：网络安全日志至少保存6个月；具体风险事件仅在案件、争议和法定义务所需范围及期限内保留。拒绝影响：必要安全信息无法提供时，部分高风险操作可能无法完成。控制方式：可通过帮助中心对风险限制提出申诉或要求解释。",
            "公开下载与法律文档网页：处理IP地址、浏览器类型、访问时间、请求路径、响应状态。来源：用户浏览器请求和服务器日志。目的：提供下载、邀请和法律文档页面，保障网站安全和排查故障。方式：服务器自动记录必要访问日志；公开法律页面不使用广告Cookie或跨站追踪。触发时机：访问igifthouse.com公开页面时。保存：网络安全日志至少保存6个月，期满按安全和审计规则处理。拒绝影响：停止访问后不再产生新的网页请求日志。控制方式：可关闭网页；浏览器本地缓存可在浏览器设置中清理。"
          ],
          "paragraphStyles": [
            "normal",
            "normal",
            "normal",
            "normal",
            "normal",
            "normal",
            "normal",
            "normal",
            "normal",
            "normal",
            "normal",
            "normal",
            "normal"
          ]
        },
        {
          "title": "敏感个人信息与单独同意",
          "paragraphs": [
            "手机号、身份证件号码、支付宝账号标识、支付、提现、订单和返利信息可能影响身份和财产安全。我们仅在账号验证、返利归因、支付、提现、财税或争议处理所必需时处理，并在具体收集页面说明目的、必要性和拒绝影响，由用户主动提交或确认。",
            "当前系统对姓名和身份证号仅按用户提交保存，尚未接入权威实名认证供应商，不会将其描述为已经通过权威数据源认证。接入新认证服务前将更新接收方、信息范围和同意方式。"
          ],
          "paragraphStyles": [
            "sensitive",
            "sensitive"
          ]
        },
        {
          "title": "系统权限、剪贴板与后台运行",
          "paragraphs": [
            "android.permission.INTERNET（佣值选）：访问佣值选服务端以及当前版本已开放且用户主动使用的登录、支付和淘宝授权等联网服务。触发时机：使用联网功能时。拒绝影响：设备无法联网时，在线商品、账号和交易相关功能不可用。",
            "android.permission.ACCESS_NETWORK_STATE（佣值选及必要组件）：判断网络是否可用，避免无网络时重复发起请求。触发时机：发起在线请求前。拒绝影响：该普通权限由系统随安装授予。",
            "android.permission.ACCESS_WIFI_STATE（阿里百川电商 SDK）：完成淘宝授权、跳转、安全风控和运行保障。触发时机：用户同意隐私政策并登录后初始化百川，主动使用淘宝功能时调用。拒绝影响：可能影响淘宝授权或跳转，不影响匿名基础浏览。",
            "android.permission.POST_NOTIFICATIONS（佣值选）：发送商品降价、返利到账和账户服务通知。触发时机：用户主动开启通知相关功能时申请。拒绝影响：不会收到系统通知，不影响应用内浏览和查询。",
            "android.permission.WAKE_LOCK（Android WorkManager）：在执行用户已启用的价格提醒短时任务时避免设备立即休眠。触发时机：价格提醒后台任务实际运行时。拒绝影响：该普通权限由系统随安装授予，关闭价格提醒后不再安排对应账号任务。",
            "android.permission.RECEIVE_BOOT_COMPLETED（Android WorkManager）：设备重启后恢复用户此前启用的价格提醒计划。触发时机：设备完成启动且用户已同意当前政策并保留有效账号时。拒绝影响：该普通权限由系统随安装授予，可通过关闭价格提醒或应用通知停止相应提醒。",
            "android.permission.FOREGROUND_SERVICE（Android WorkManager）：支持系统在必要时以受控前台服务执行已启用的后台任务。触发时机：仅在系统调度和任务条件需要时。拒绝影响：该普通权限由系统随安装授予。"
          ],
          "paragraphStyles": [
            "normal",
            "normal",
            "normal",
            "normal",
            "normal",
            "normal",
            "normal"
          ]
        },
        {
          "title": "Cookie、本地存储和公开网页日志",
          "paragraphs": [
            "Android在设备本地保存登录状态、同意版本、偏好、浏览历史、收藏和必要缓存，用于维持功能。用户可通过应用功能、系统设置或卸载管理本地数据。",
            "公开下载和法律页面不使用广告Cookie或跨站追踪；服务器会记录IP地址、访问时间、请求路径、浏览器类型和响应状态，用于安全与故障排查。管理后台使用会话存储维持管理员登录，不属于面向普通用户的公开功能。"
          ],
          "paragraphStyles": [
            "normal",
            "normal"
          ]
        },
        {
          "title": "委托处理、共享、转让和公开披露",
          "paragraphs": [
            "我们不会出售个人信息。为提供短信、对象存储、支付、淘宝授权和故障诊断，以及仅在开放并经用户确认后使用的AI导购，会在必要范围内委托或向第三方提供相应信息，接收方及范围见第三方信息共享清单。",
            "发生合并、分立、收购、资产转让等个人信息转移时，我们将依法告知接收方并要求其继续履行保护义务；处理目的或方式变化时依法重新取得同意。",
            "除取得单独同意或法律法规、诉讼、行政司法机关依法要求等情形外，我们不公开披露个人信息。紧急保护生命健康和财产安全等法定情形按法律允许范围处理。"
          ],
          "paragraphStyles": [
            "normal",
            "normal",
            "normal"
          ]
        },
        {
          "title": "第三方 SDK、API 和云服务",
          "paragraphs": [
            "版本：服务端 API。主体：阿里云计算有限公司。用途：发送登录、手机号换绑和账号注销验证码。信息类型：手机号码、验证码模板参数、短信签名与模板编号、发送结果和请求编号。处理方式：佣值选服务端通过加密网络调用阿里云短信 API。调用时机：用户主动请求相应验证码时。保存：验证码在佣值选缓存中通常保存5分钟；服务商侧记录按其服务规则处理。用户控制：不请求验证码时不调用；拒绝将无法完成依赖短信验证的登录、换绑或注销。官方政策：https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202107091605_49213.html",
            "版本：服务端 API。主体：阿里云计算有限公司。用途：保存用户主动上传的头像、帮助中心反馈图片及必要文件元数据。信息类型：头像图片、反馈图片、文件类型、文件大小、内部用户关联和对象路径。处理方式：佣值选服务端校验、压缩或转换后，通过加密网络上传至中国大陆 OSS 节点。调用时机：用户主动上传头像或反馈附件时。保存：头像在用户使用对应资料期间保存；未提交工单的临时附件按后台清理规则处理；已提交附件按客服和争议处理所需期限保存。用户控制：不上传不处理；用户可更换头像，或通过帮助中心申请处理已上传信息。官方政策：https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202107091605_49213.html",
            "版本：4.2.0.0。主体：浙江淘宝网络有限公司。用途：用户主动购买或授权时唤起淘宝客户端，或在淘宝不可用时承载淘宝 H5。信息类型：BSSID、SSID、运营商信息、AndroidID、OAID、GAID、应用信息、操作信息、网络环境信息。处理方式：SDK 在本机处理必要环境信息并通过加密网络与淘宝服务通信。调用时机：用户同意当前政策并登录后初始化，主动购买或授权时调用。保存：由淘宝按其隐私规则和服务目的所需期限处理。用户控制：拒绝淘宝授权不影响匿名基础浏览，但无法完成返利归因。随包组件：AlibcTradeBiz 4.2.0.0、AlibcTradeCommon 4.2.0.0、Alibaba Auth Core 2.2.1-sg、Alibaba Auth Baichuan Extension 2.2.1-sg、Alibaba Auth UI 2.2.1-sg、Alibc Link Partner 4.1.31-SNAPSHOT、MTop SDK 3.1.22-privacy3、NB Trade 4.2.0.0、OSMSS3rd Adapter 0.0.4、OSMSS3rd Android 0.0.7、OSMSS3rd Core 0.0.1、UT Analytics 6.5.8.28、UTDID 1.5.3。官方政策：https://terms.alicdn.com/legal-agreement/terms/suit_bu1_taobao/suit_bu1_taobao202107141244_11649.html",
            "版本：6.8.0。主体：深圳市腾讯计算机系统有限公司。用途：微信登录、账号绑定、换绑和授权回调。信息类型：微信授权 code、openid、unionid、微信昵称、微信头像、必要应用与网络环境信息。处理方式：客户端调起微信授权，佣值选服务端使用一次性 code 换取授权结果。调用时机：用户主动选择微信登录、绑定或换绑时。保存：一次性 code 和短期绑定令牌过期后失效；绑定标识在账号服务期间保存，注销后按分类留存规则处理。用户控制：拒绝不影响手机号登录；已登录用户可在账号安全中解绑。官方政策：https://privacy.qq.com/document/preview/bdf936b2477a45ff86da57e3d988bc2b",
            "版本：Android SDK 15.8.17。主体：支付宝（中国）网络技术有限公司。用途：会员支付、支付宝收款账户授权、提现转账和结果查询。信息类型：支付宝账号标识、授权结果、支付订单、交易号、金额、支付和提现状态、必要设备与网络风控信息。处理方式：客户端主动拉起支付宝，服务端通过签名请求和回调处理支付或转账结果；收款账号按配置加密保存。调用时机：用户主动发起支付宝授权、会员支付或提现时。保存：授权临时参数按短期有效期处理；交易和提现记录自交易完成之日起至少保存3年，法律法规要求更长的从其规定。用户控制：不使用相应功能时不调用；可在钱包中解除收款账户绑定，但历史交易记录不因此删除。官方政策：https://opendocs.alipay.com/open/01g6qm",
            "版本：deepseek-chat。主体：杭州深度求索人工智能基础技术研究有限公司。用途：在AI导购开放且用户主动使用时理解购物需求并生成商品分析和导购建议。信息类型：用户主动输入的问题、当前页面历史对话、相关商品信息、用户主动提交的解析内容。处理方式：针对AI导购中的个人信息处理，经用户确认AI数据处理说明后，由佣值选服务端通过加密网络调用DeepSeek API，不主动附带用户账号、手机号、登录令牌或设备标识。调用时机：AI导购中的个人信息处理仅在当前版本或渠道开放该功能，且用户确认说明后主动提问时发生。保存：佣值选不将本页会话保存为长期账号对话历史；DeepSeek 按开放平台协议和隐私政策处理接口输入输出。用户控制：可拒绝或停止使用AI导购，不影响商品搜索、浏览和其他服务。请勿输入与购物无关的敏感信息。模型公示：求索对话 DeepSeek Chat，生成式人工智能服务备案号Beijing-DeepseekChat-202404280016，DeepSeek大语言模型算法备案号网信算备110108970550101240011号。官方政策：https://cdn.deepseek.com/policies/zh-CN/deepseek-privacy-policy.html",
            "版本：4.1.9.3。主体：深圳市腾讯计算机系统有限公司。用途：崩溃和 ANR 统计、定位及稳定性诊断。信息类型：应用版本、SDK版本、Android系统版本、设备型号、进程状态、异常堆栈、必要设备与网络环境信息。处理方式：用户同意后 SDK 自动采集故障及必要运行环境信息并通过加密网络上报。调用时机：用户同意当前政策后初始化，发生崩溃或 ANR 等故障时上报。保存：按 Bugly 服务规则及故障分析所需期限处理。用户控制：撤回隐私同意后停止初始化，不设置佣值选业务用户 ID。官方政策：https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56"
          ],
          "paragraphStyles": [
            "normal",
            "normal",
            "normal",
            "normal",
            "normal",
            "normal",
            "normal"
          ]
        },
        {
          "title": "存储地点、跨境和保存期限",
          "paragraphs": [
            "个人信息存储在中华人民共和国境内，当前主要使用阿里云中国大陆节点。根据当前产品和生产配置，我们不主动向境外提供个人信息；如将来发生，将依法单独告知并履行相应程序。",
            "验证码通常保存5分钟；微信绑定临时令牌和淘宝授权state通常10分钟内有效；待投递价格提醒通常最多72小时；网络安全日志至少6个月；商品和服务信息、交易信息自交易完成之日起至少3年。其他资料按各处理活动列明的目的和确定方式保存，目的实现且无其他合法依据后删除或匿名化。",
            "账号注销采用软标识：账号停止登录但服务端资料和业务关联不在注销动作中立即物理清空。保留信息不再用于原账号登录、个性化推荐或营销，并按履约、账务、争议、安全和用户权利处理所需范围限制访问。"
          ],
          "paragraphStyles": [
            "normal",
            "normal",
            "normal"
          ]
        },
        {
          "title": "自动化决策、推荐和AI导购",
          "paragraphs": [
            "当前首页主要使用商品价格、销量、优惠和返利等商品侧信号进行通用排序。关闭“个性化推荐”后继续使用不基于个人画像的通用结果；在真正启用基于个人行为的排序前，我们会更新具体逻辑和影响。",
            "AI导购仅在当前版本或渠道开放时提供。用户阅读并确认AI数据处理说明后主动提交的问题和本页上下文用于生成建议，不用于决定用户支付价格、提现资格或其他重大权益。未开放时不通过对话导购功能收集或发送问题和会话。",
            "风控规则可能限制异常高风险操作，用户可通过帮助中心要求解释或申请人工复核。",
            "DeepSeek模型公示：求索对话 DeepSeek Chat，生成式人工智能服务备案号 Beijing-DeepseekChat-202404280016；DeepSeek大语言模型算法备案号 网信算备110108970550101240011号。佣值选如依法取得应用上线编号，将在产品显著位置补充公示。"
          ],
          "paragraphStyles": [
            "normal",
            "normal",
            "normal",
            "normal"
          ]
        },
        {
          "title": "安全措施与安全事件",
          "paragraphs": [
            "我们采取HTTPS传输、访问控制、签名和幂等校验、敏感账号加密、限流、日志审计、备份和异常监测等措施，降低未经授权访问、泄露、篡改和丢失风险。",
            "发生个人信息安全事件时，我们会及时采取补救措施，并依法通过App通知、邮件、公告或其他有效方式告知事件情况、可能影响、处置措施和用户防范建议；依法需要时向主管部门报告。"
          ],
          "paragraphStyles": [
            "normal",
            "normal"
          ]
        },
        {
          "title": "个人信息权利与账号注销",
          "paragraphs": [
            "用户可在个人资料页修改昵称和头像，在账号安全中换绑手机号、绑定或解绑微信并申请注销，在隐私管理中查看政策、调整推荐和剪贴板偏好、进入系统权限页或撤回隐私同意。",
            "当前隐私管理页不直接提供完整数据副本导出或特定服务器记录删除功能。查询、复制、更正、删除、限制处理、解释自动化决策，或无法登录后的注销请求，请通过帮助中心或 944195790@qq.com 提交。我们核验必要身份后通常在十五个工作日内反馈；暂不能处理时会说明原因。",
            "撤回同意不影响撤回前处理的效力。撤回后停止基于同意的可选处理、退出账号并回到同意页面；履约、安全和法定义务所必需的处理按适用依据继续。"
          ],
          "paragraphStyles": [
            "normal",
            "normal",
            "normal"
          ]
        },
        {
          "title": "未成年人保护",
          "paragraphs": [
            "佣值选主要面向成年人。未满14周岁的儿童应在父母或其他监护人同意和指导下使用；未经监护人同意，不应提交儿童个人信息。",
            "发现未经可验证的监护人同意处理儿童个人信息时，我们将停止相关处理并依法删除或采取其他必要措施。"
          ],
          "paragraphStyles": [
            "normal",
            "normal"
          ]
        },
        {
          "title": "停止运营与政策更新",
          "paragraphs": [
            "如停止运营，我们将通过公告或其他适当方式通知，停止继续收集个人信息，并依法删除、匿名化或在法定期限内受限保存现有信息。",
            "处理目的、方式、信息种类、敏感信息、共享对象或跨境情况发生实质变化时，我们会更新政策版本并重新取得必要同意；仅排版或不影响权益的文字修正更新文档修订标识。"
          ],
          "paragraphStyles": [
            "normal",
            "normal"
          ]
        },
        {
          "title": "联系、投诉和举报",
          "paragraphs": [
            "隐私权利、投诉、举报或安全问题可通过App内“我的-帮助中心-提交反馈”或客服邮箱 944195790@qq.com 联系深圳市礼屋科技有限公司。我们通常在十五个工作日内核查并反馈。",
            "如对处理结果不满意，可依法向履行个人信息保护职责的主管部门投诉，或通过法律规定的其他途径维护权益。"
          ],
          "paragraphStyles": [
            "normal",
            "normal"
          ]
        }
      ]
    },
    "accountDeletion": {
      "title": "账号注销说明",
      "summary": "用户可在App内注销账号；未结资金和处理中交易需先完成处理。",
      "sections": [
        {
          "title": "操作入口与验证",
          "paragraphs": [
            "登录后进入“我的-设置-账号与安全-注销账号”，完成资格检查、风险确认和当前手机号的注销专用短信验证。验证码、资格令牌和幂等请求标识仅用于本次注销。"
          ],
          "paragraphStyles": [
            "normal"
          ]
        },
        {
          "title": "暂不能注销的情形",
          "paragraphs": [
            "可用、锁定、待结算或欠款余额不为零，存在处理中提现、会员支付或退款，返利订单尚未结算等会影响资金权益的事项时，需要先完成相应处理。"
          ],
          "paragraphStyles": [
            "normal"
          ]
        },
        {
          "title": "注销结果",
          "paragraphs": [
            "注销成功后访问令牌和刷新令牌失效，账号标记为已注销并停止登录，原账号不可恢复。原手机号重新验证时会创建新的用户ID，不继承旧账号的资料、资产、会员、返利、订单、绑定、邀请码或邀请关系。",
            "注销后的个人信息按照隐私政策及适用法律规则处理。如需查询、复制、更正或删除特定信息，可通过客服邮箱提交请求。"
          ],
          "paragraphStyles": [
            "normal",
            "normal"
          ]
        },
        {
          "title": "帮助与反馈",
          "paragraphs": [
            "无法登录、资格阻断或个人信息权利问题可通过App帮助中心或 944195790@qq.com 联系。我们核验必要身份后通常在十五个工作日内反馈。"
          ],
          "paragraphStyles": [
            "normal"
          ]
        }
      ]
    },
    "personalInfoList": {
      "title": "个人信息收集清单",
      "summary": "按功能列明信息类型、来源、目的、方式、触发时机、保存规则、拒绝影响和用户控制。",
      "sections": [
        {
          "title": "基本功能和安全所需信息",
          "paragraphs": [
            "匿名基础浏览、搜索和商品详情：处理搜索关键词、商品标识、平台来源、IP地址、请求时间和网络日志。来源：用户输入、客户端请求和服务器自动生成。目的：返回商品列表、搜索结果和详情，保障接口安全与稳定。方式：通过 HTTPS 传输；匿名基础浏览不携带登录令牌，不写入账号浏览或收藏历史。触发时机：用户打开基础浏览、搜索或详情时。保存：搜索趋势记录不绑定用户账号；网络安全日志至少保存6个月，期满按安全和审计规则处理。拒绝影响：不联网无法获取在线商品数据。控制方式：可以停止搜索或退出应用。",
            "手机号注册、登录、换绑和注销验证：处理手机号码、短信验证码校验结果、用户ID、访问令牌、刷新令牌、账号状态。来源：用户主动提供及系统生成。目的：识别账号、保护账号安全和提供账户服务。方式：HTTPS传输，验证码和令牌按短期有效期校验，密码或令牌不向第三方公开。触发时机：用户主动注册、登录、换绑手机号或注销账号时。本项涉及敏感个人信息。必要性：手机号用于完成账号身份验证，是登录和资金权益归属的必要信息；可能影响：泄露可能导致骚扰、账号冒用或财产风险，因此采用脱敏展示、限流和访问控制；同意方式：在注册登录及相应高风险操作页面取得明确同意和主动提交。保存：验证码通常保存5分钟；令牌按有效期保存；账号资料在账号服务期间保存，注销后按软标识和分类留存规则处理。拒绝影响：无法登录和使用返利、会员、钱包、提现、收藏等账号功能。控制方式：可退出登录、换绑手机号或申请注销账号。",
            "账号、接口和资金安全：处理IP地址、请求时间、接口结果、应用版本、设备型号和系统版本、实际提供时的设备指纹、风险事件和不可逆关联标识。来源：客户端请求、服务器日志和安全规则产生。目的：身份验证、限流、防刷、反作弊、资金风险判断、故障排查和安全审计。方式：通过访问控制、限流和日志审计处理；风险关联值使用独立HMAC密钥，不把哈希结果视为匿名化。触发时机：登录、高风险操作、接口异常或安全事件发生时。保存：网络安全日志至少保存6个月；具体风险事件仅在案件、争议和法定义务所需范围及期限内保留。拒绝影响：必要安全信息无法提供时，部分高风险操作可能无法完成。控制方式：可通过帮助中心对风险限制提出申诉或要求解释。",
            "公开下载与法律文档网页：处理IP地址、浏览器类型、访问时间、请求路径、响应状态。来源：用户浏览器请求和服务器日志。目的：提供下载、邀请和法律文档页面，保障网站安全和排查故障。方式：服务器自动记录必要访问日志；公开法律页面不使用广告Cookie或跨站追踪。触发时机：访问igifthouse.com公开页面时。保存：网络安全日志至少保存6个月，期满按安全和审计规则处理。拒绝影响：停止访问后不再产生新的网页请求日志。控制方式：可关闭网页；浏览器本地缓存可在浏览器设置中清理。"
          ],
          "paragraphStyles": [
            "normal",
            "sensitive",
            "normal",
            "normal"
          ]
        },
        {
          "title": "附加功能信息",
          "paragraphs": [
            "个人资料：处理昵称、头像图片、头像地址。来源：用户主动填写或上传。目的：展示个人资料并便于客服识别。方式：头像经服务端校验和压缩后保存到阿里云 OSS。触发时机：用户主动编辑资料时。保存：在使用对应资料期间保存，更换后旧引用停止使用；注销后按分类留存规则处理。拒绝影响：不影响基本浏览、登录和交易权益。控制方式：可在个人资料页修改。",
            "浏览、收藏、搜索偏好和推荐设置：处理搜索关键词、浏览记录、收藏记录、商品点击、推荐开关。来源：用户使用功能时产生。目的：展示历史、收藏和通用推荐，改善商品发现体验。方式：部分记录保存在本地，账号关联记录通过HTTPS保存至服务端；当前关闭个性化推荐后使用不基于个人画像的通用排序。触发时机：用户搜索、浏览、收藏或调整推荐设置时。保存：本地记录保存至用户清理、退出相关流程或卸载；服务端记录在功能使用期间保存，注销后按分类留存规则处理。拒绝影响：不影响基本浏览和搜索，但无法获得历史、收藏或相应偏好体验。控制方式：可清理历史、取消收藏并在隐私管理中关闭个性化推荐。",
            "剪贴板商品识别：处理用户主动粘贴或单独开启自动识别后的剪贴板文本。来源：设备剪贴板。目的：识别淘宝商品链接或口令并展示商品预览。方式：默认不读取；用户主动粘贴时单次读取，或单独开启后在进入首页/回到前台时读取一次；不保存无关原文。触发时机：主动点击粘贴，或已开启自动识别且首页获得焦点时。保存：仅在当前识别流程处理，不保存剪贴板原文；本地只记录不可逆内容标识用于避免重复提示。拒绝影响：不影响其他功能，可手动输入商品关键词。控制方式：可在隐私管理随时关闭自动识别。",
            "价格监控与后台提醒：处理登录账号ID、商品标识、目标价格、监控状态、通知投递状态。来源：用户主动设置及系统任务产生。目的：联网检查已监控商品价格并在达到条件时通知用户。方式：用户启用后由Android WorkManager按系统调度周期联网检查，通常最短间隔15分钟；设备重启后可恢复计划。触发时机：用户主动添加价格监控且同意当前隐私政策、账号有效时。保存：监控设置保存至用户取消、商品失效或权益终止；待投递提醒通常最多保留72小时。拒绝影响：关闭后不会收到相应降价提醒，不影响商品浏览。控制方式：可删除价格监控、关闭应用内通知设置或系统通知权限。",
            "淘宝授权、购买跳转、订单归因和返利：处理一次性授权state、淘宝渠道关系ID、订单号、商品、订单金额、佣金、返利、结算和退款状态。来源：用户授权、淘宝联盟和订单同步接口。目的：生成推广链接、关联淘宝订单、计算返利、处理结算和退款。方式：客户端跳转淘宝授权，服务端以加密凭据调用淘宝接口并按订单号幂等处理。触发时机：用户主动授权或购买并满足淘宝订单回流条件时。本项涉及敏感个人信息。必要性：交易和渠道关系信息用于确定订单归属、返利金额及退款责任；可能影响：泄露可能暴露消费和财产状况，因此限制访问并对凭据加密保存；同意方式：在淘宝渠道授权前单独提示并由用户主动确认。保存：授权state通常10分钟内有效；交易及返利信息自交易完成之日起至少保存3年，法律法规要求更长的从其规定。拒绝影响：仍可浏览商品，但无法追踪淘宝订单及获得对应返利。控制方式：可拒绝或撤回淘宝渠道授权；既有订单继续按结算、退款和法定义务处理。",
            "会员购买和支付：处理会员方案、支付订单号、支付宝交易号、支付金额、支付状态、退款状态。来源：用户下单、支付宝回调和服务端查单。目的：创建会员订单、确认支付、开通权益、处理退款和争议。方式：服务端签名下单并验证支付宝回调签名、金额、订单归属和幂等状态。触发时机：用户主动选择会员并发起支付宝支付时。本项涉及敏感个人信息。必要性：交易信息是确认付款、提供会员权益和处理售后的必要信息；可能影响：泄露可能暴露交易和财产信息，因此采用加密传输、签名校验和最小权限；同意方式：购买页展示价格和权益后由用户主动确认支付。保存：支付和会员交易信息自交易完成之日起至少保存3年，适用会计、税务或争议规则要求更长的从其规定。拒绝影响：无法购买会员，不影响免费基础服务。控制方式：可取消未支付订单，并通过帮助中心咨询支付或退款。",
            "支付宝收款账户、实名资料和提现：处理姓名、身份证件号码、支付宝账号标识、提现金额、手续费、到账金额、渠道流水号、提现和风险状态。来源：用户主动提交、支付宝授权及转账查询结果。目的：绑定收款账户、校验提现资格、转账、对账、税务和争议处理。方式：收款账号按配置加密保存，身份证件和资金记录限制后台访问；当前姓名和身份证号仅按用户提交保存，尚未接入权威实名认证供应商。触发时机：用户主动绑定支付宝、提交实名资料或申请提现时。本项涉及敏感个人信息。必要性：身份和金融账户信息用于确认收款人、保护资金安全及履行适用财税义务；可能影响：泄露可能造成身份冒用、诈骗或财产损失，因此需要单独同意、加密传输和访问控制；同意方式：在提交实名资料、绑定收款账户和提现确认页面分别取得主动确认。保存：提现和账务信息自交易完成之日起至少保存3年，适用财税或反欺诈规则要求更长的从其规定；授权临时参数到期失效。拒绝影响：无法绑定收款账户或提现，不影响商品浏览和已取得权益查询。控制方式：可在不存在处理中提现时解绑或更换支付宝账户，并通过帮助中心申请个人信息权利。",
            "帮助中心与问题反馈：处理反馈标题和正文、工单消息、用户主动上传的图片、联系方式、工单状态和处理记录。来源：用户主动提交及客服处理产生。目的：定位问题、回复用户、处理投诉和争议。方式：正文保存至受限工单系统，附件校验后保存至阿里云OSS；客服按角色访问。触发时机：用户主动提交反馈、回复工单或上传附件时。保存：未关联工单的临时附件按后台清理规则处理；已提交内容保存至问题处理完成及必要争议期结束，之后删除或匿名化。拒绝影响：无法通过工单获得针对性帮助，可使用公开客服邮箱联系。控制方式：提交前可不添加附件；可通过工单或客服邮箱申请处理相关信息。",
            "AI 导购（仅限已开放版本或渠道）：处理用户购物问题、本页对话、相关商品信息、用户主动粘贴的解析内容。来源：用户主动输入及服务端商品数据。目的：生成购物需求分析、候选商品和导购建议。方式：经单独说明和确认后，由服务端将必要上下文发送至DeepSeek API；返回内容经商品事实校验或使用本地兜底。触发时机：当前版本或渠道开放AI导购，且用户主动进入并同意AI数据处理说明后提交问题时；未开放时不通过该功能处理对话内容。保存：佣值选仅在当前页面会话中保留上下文，不保存为长期账号聊天历史。拒绝影响：无法使用AI导购，不影响商品搜索、浏览和其他服务。控制方式：可拒绝、关闭页面或停止输入；已发送内容的权利请求可联系帮助中心。"
          ],
          "paragraphStyles": [
            "normal",
            "normal",
            "normal",
            "normal",
            "sensitive",
            "sensitive",
            "sensitive",
            "normal",
            "normal"
          ]
        },
        {
          "title": "敏感个人信息汇总",
          "paragraphs": [
            "手机号注册、登录、换绑和注销验证：处理手机号码、短信验证码校验结果、用户ID、访问令牌、刷新令牌、账号状态。来源：用户主动提供及系统生成。目的：识别账号、保护账号安全和提供账户服务。方式：HTTPS传输，验证码和令牌按短期有效期校验，密码或令牌不向第三方公开。触发时机：用户主动注册、登录、换绑手机号或注销账号时。本项涉及敏感个人信息。必要性：手机号用于完成账号身份验证，是登录和资金权益归属的必要信息；可能影响：泄露可能导致骚扰、账号冒用或财产风险，因此采用脱敏展示、限流和访问控制；同意方式：在注册登录及相应高风险操作页面取得明确同意和主动提交。保存：验证码通常保存5分钟；令牌按有效期保存；账号资料在账号服务期间保存，注销后按软标识和分类留存规则处理。拒绝影响：无法登录和使用返利、会员、钱包、提现、收藏等账号功能。控制方式：可退出登录、换绑手机号或申请注销账号。",
            "淘宝授权、购买跳转、订单归因和返利：处理一次性授权state、淘宝渠道关系ID、订单号、商品、订单金额、佣金、返利、结算和退款状态。来源：用户授权、淘宝联盟和订单同步接口。目的：生成推广链接、关联淘宝订单、计算返利、处理结算和退款。方式：客户端跳转淘宝授权，服务端以加密凭据调用淘宝接口并按订单号幂等处理。触发时机：用户主动授权或购买并满足淘宝订单回流条件时。本项涉及敏感个人信息。必要性：交易和渠道关系信息用于确定订单归属、返利金额及退款责任；可能影响：泄露可能暴露消费和财产状况，因此限制访问并对凭据加密保存；同意方式：在淘宝渠道授权前单独提示并由用户主动确认。保存：授权state通常10分钟内有效；交易及返利信息自交易完成之日起至少保存3年，法律法规要求更长的从其规定。拒绝影响：仍可浏览商品，但无法追踪淘宝订单及获得对应返利。控制方式：可拒绝或撤回淘宝渠道授权；既有订单继续按结算、退款和法定义务处理。",
            "会员购买和支付：处理会员方案、支付订单号、支付宝交易号、支付金额、支付状态、退款状态。来源：用户下单、支付宝回调和服务端查单。目的：创建会员订单、确认支付、开通权益、处理退款和争议。方式：服务端签名下单并验证支付宝回调签名、金额、订单归属和幂等状态。触发时机：用户主动选择会员并发起支付宝支付时。本项涉及敏感个人信息。必要性：交易信息是确认付款、提供会员权益和处理售后的必要信息；可能影响：泄露可能暴露交易和财产信息，因此采用加密传输、签名校验和最小权限；同意方式：购买页展示价格和权益后由用户主动确认支付。保存：支付和会员交易信息自交易完成之日起至少保存3年，适用会计、税务或争议规则要求更长的从其规定。拒绝影响：无法购买会员，不影响免费基础服务。控制方式：可取消未支付订单，并通过帮助中心咨询支付或退款。",
            "支付宝收款账户、实名资料和提现：处理姓名、身份证件号码、支付宝账号标识、提现金额、手续费、到账金额、渠道流水号、提现和风险状态。来源：用户主动提交、支付宝授权及转账查询结果。目的：绑定收款账户、校验提现资格、转账、对账、税务和争议处理。方式：收款账号按配置加密保存，身份证件和资金记录限制后台访问；当前姓名和身份证号仅按用户提交保存，尚未接入权威实名认证供应商。触发时机：用户主动绑定支付宝、提交实名资料或申请提现时。本项涉及敏感个人信息。必要性：身份和金融账户信息用于确认收款人、保护资金安全及履行适用财税义务；可能影响：泄露可能造成身份冒用、诈骗或财产损失，因此需要单独同意、加密传输和访问控制；同意方式：在提交实名资料、绑定收款账户和提现确认页面分别取得主动确认。保存：提现和账务信息自交易完成之日起至少保存3年，适用财税或反欺诈规则要求更长的从其规定；授权临时参数到期失效。拒绝影响：无法绑定收款账户或提现，不影响商品浏览和已取得权益查询。控制方式：可在不存在处理中提现时解绑或更换支付宝账户，并通过帮助中心申请个人信息权利。"
          ],
          "paragraphStyles": [
            "sensitive",
            "sensitive",
            "sensitive",
            "sensitive"
          ]
        }
      ]
    },
    "sdkList": {
      "title": "第三方信息共享清单",
      "summary": "逐项列明客户端 SDK、服务端 API 和云服务处理者及其真实数据处理范围。",
      "sections": [
        {
          "title": "阿里云短信服务",
          "paragraphs": [
            "版本：服务端 API。主体：阿里云计算有限公司。用途：发送登录、手机号换绑和账号注销验证码。信息类型：手机号码、验证码模板参数、短信签名与模板编号、发送结果和请求编号。处理方式：佣值选服务端通过加密网络调用阿里云短信 API。调用时机：用户主动请求相应验证码时。保存：验证码在佣值选缓存中通常保存5分钟；服务商侧记录按其服务规则处理。用户控制：不请求验证码时不调用；拒绝将无法完成依赖短信验证的登录、换绑或注销。官方政策：https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202107091605_49213.html"
          ],
          "paragraphStyles": [
            "normal"
          ]
        },
        {
          "title": "阿里云对象存储 OSS",
          "paragraphs": [
            "版本：服务端 API。主体：阿里云计算有限公司。用途：保存用户主动上传的头像、帮助中心反馈图片及必要文件元数据。信息类型：头像图片、反馈图片、文件类型、文件大小、内部用户关联和对象路径。处理方式：佣值选服务端校验、压缩或转换后，通过加密网络上传至中国大陆 OSS 节点。调用时机：用户主动上传头像或反馈附件时。保存：头像在用户使用对应资料期间保存；未提交工单的临时附件按后台清理规则处理；已提交附件按客服和争议处理所需期限保存。用户控制：不上传不处理；用户可更换头像，或通过帮助中心申请处理已上传信息。官方政策：https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202107091605_49213.html"
          ],
          "paragraphStyles": [
            "normal"
          ]
        },
        {
          "title": "阿里百川电商 SDK",
          "paragraphs": [
            "版本：4.2.0.0。主体：浙江淘宝网络有限公司。用途：用户主动购买或授权时唤起淘宝客户端，或在淘宝不可用时承载淘宝 H5。信息类型：BSSID、SSID、运营商信息、AndroidID、OAID、GAID、应用信息、操作信息、网络环境信息。处理方式：SDK 在本机处理必要环境信息并通过加密网络与淘宝服务通信。调用时机：用户同意当前政策并登录后初始化，主动购买或授权时调用。保存：由淘宝按其隐私规则和服务目的所需期限处理。用户控制：拒绝淘宝授权不影响匿名基础浏览，但无法完成返利归因。随包组件：AlibcTradeBiz 4.2.0.0、AlibcTradeCommon 4.2.0.0、Alibaba Auth Core 2.2.1-sg、Alibaba Auth Baichuan Extension 2.2.1-sg、Alibaba Auth UI 2.2.1-sg、Alibc Link Partner 4.1.31-SNAPSHOT、MTop SDK 3.1.22-privacy3、NB Trade 4.2.0.0、OSMSS3rd Adapter 0.0.4、OSMSS3rd Android 0.0.7、OSMSS3rd Core 0.0.1、UT Analytics 6.5.8.28、UTDID 1.5.3。官方政策：https://terms.alicdn.com/legal-agreement/terms/suit_bu1_taobao/suit_bu1_taobao202107141244_11649.html"
          ],
          "paragraphStyles": [
            "normal"
          ]
        },
        {
          "title": "微信 OpenSDK",
          "paragraphs": [
            "版本：6.8.0。主体：深圳市腾讯计算机系统有限公司。用途：微信登录、账号绑定、换绑和授权回调。信息类型：微信授权 code、openid、unionid、微信昵称、微信头像、必要应用与网络环境信息。处理方式：客户端调起微信授权，佣值选服务端使用一次性 code 换取授权结果。调用时机：用户主动选择微信登录、绑定或换绑时。保存：一次性 code 和短期绑定令牌过期后失效；绑定标识在账号服务期间保存，注销后按分类留存规则处理。用户控制：拒绝不影响手机号登录；已登录用户可在账号安全中解绑。官方政策：https://privacy.qq.com/document/preview/bdf936b2477a45ff86da57e3d988bc2b"
          ],
          "paragraphStyles": [
            "normal"
          ]
        },
        {
          "title": "支付宝 SDK 与开放平台 API",
          "paragraphs": [
            "版本：Android SDK 15.8.17。主体：支付宝（中国）网络技术有限公司。用途：会员支付、支付宝收款账户授权、提现转账和结果查询。信息类型：支付宝账号标识、授权结果、支付订单、交易号、金额、支付和提现状态、必要设备与网络风控信息。处理方式：客户端主动拉起支付宝，服务端通过签名请求和回调处理支付或转账结果；收款账号按配置加密保存。调用时机：用户主动发起支付宝授权、会员支付或提现时。保存：授权临时参数按短期有效期处理；交易和提现记录自交易完成之日起至少保存3年，法律法规要求更长的从其规定。用户控制：不使用相应功能时不调用；可在钱包中解除收款账户绑定，但历史交易记录不因此删除。官方政策：https://opendocs.alipay.com/open/01g6qm"
          ],
          "paragraphStyles": [
            "normal"
          ]
        },
        {
          "title": "DeepSeek API",
          "paragraphs": [
            "版本：deepseek-chat。主体：杭州深度求索人工智能基础技术研究有限公司。用途：在AI导购开放且用户主动使用时理解购物需求并生成商品分析和导购建议。信息类型：用户主动输入的问题、当前页面历史对话、相关商品信息、用户主动提交的解析内容。处理方式：针对AI导购中的个人信息处理，经用户确认AI数据处理说明后，由佣值选服务端通过加密网络调用DeepSeek API，不主动附带用户账号、手机号、登录令牌或设备标识。调用时机：AI导购中的个人信息处理仅在当前版本或渠道开放该功能，且用户确认说明后主动提问时发生。保存：佣值选不将本页会话保存为长期账号对话历史；DeepSeek 按开放平台协议和隐私政策处理接口输入输出。用户控制：可拒绝或停止使用AI导购，不影响商品搜索、浏览和其他服务。请勿输入与购物无关的敏感信息。模型公示：求索对话 DeepSeek Chat，生成式人工智能服务备案号Beijing-DeepseekChat-202404280016，DeepSeek大语言模型算法备案号网信算备110108970550101240011号。官方政策：https://cdn.deepseek.com/policies/zh-CN/deepseek-privacy-policy.html"
          ],
          "paragraphStyles": [
            "normal"
          ]
        },
        {
          "title": "腾讯 Bugly",
          "paragraphs": [
            "版本：4.1.9.3。主体：深圳市腾讯计算机系统有限公司。用途：崩溃和 ANR 统计、定位及稳定性诊断。信息类型：应用版本、SDK版本、Android系统版本、设备型号、进程状态、异常堆栈、必要设备与网络环境信息。处理方式：用户同意后 SDK 自动采集故障及必要运行环境信息并通过加密网络上报。调用时机：用户同意当前政策后初始化，发生崩溃或 ANR 等故障时上报。保存：按 Bugly 服务规则及故障分析所需期限处理。用户控制：撤回隐私同意后停止初始化，不设置佣值选业务用户 ID。官方政策：https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56"
          ],
          "paragraphStyles": [
            "normal"
          ]
        }
      ]
    }
  }
};
